// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._19itglyw{border:none}
._80om13gf{cursor:not-allowed}
._80omtlke{cursor:pointer}
._r06hglyw{-webkit-appearance:none;appearance:none}
._vchhusvi{box-sizing:border-box}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/inline-edit/node_modules/@atlaskit/primitives/dist/esm/compiled/components/pressable.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW;AACtB,WAAW,kBAAkB;AAC7B,WAAW,cAAc;AACzB,WAAW,uBAAuB,CAAC,eAAe;AAClD,WAAW,qBAAqB","sourcesContent":["._19itglyw{border:none}\n._80om13gf{cursor:not-allowed}\n._80omtlke{cursor:pointer}\n._r06hglyw{-webkit-appearance:none;appearance:none}\n._vchhusvi{box-sizing:border-box}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
